const valuesQueryKeys = {
  all: ['all', 'values'] as const,
  valuesLists: () => [...valuesQueryKeys.all, 'valuesList'] as const,
  valuesList: () => [...valuesQueryKeys.valuesLists()] as const,
  widgetValuesLists: () => [...valuesQueryKeys.all, 'widgetValuesList'] as const,
  widgetValuesList: (dateFrom: string) => [...valuesQueryKeys.widgetValuesLists(), { dateFrom }] as const,
}

export default valuesQueryKeys
